module.exports = "/_next/static/images/b7563f4952b9f3f2599cdf4302f20db7-card-and-phone-3d-md@2x.jpg";